<template>
  <div id="user">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'user'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/system/user/User.vue